import { useEffect } from 'react';
import { Form, Input, Modal } from 'antd';
import {
  useDeleteParentRecommendationMutation,
  usePutParentRecommendationHoldMutation,
  useRemoveParentRecommendationHoldMutation,
} from '@/services/parent-api';

const titles = {
  putHold: 'Put recommendation on hold',
  removeHold: 'Remove recommendation hold',
  delete: 'Remove recommendation',
};

const UpdateModal = ({ parentId, status, refetch, onClose }) => {
  const [putHold, { isLoading: puttingHold }] = usePutParentRecommendationHoldMutation();
  const [removeHold, { isLoading: removingHold }] = useRemoveParentRecommendationHoldMutation();
  const [deleteRecommendation, { isLoading: deleting }] = useDeleteParentRecommendationMutation();
  const [form] = Form.useForm();

  useEffect(() => {
    if (status) {
      setTimeout(() => {
        form.resetFields();
      });
    }
  }, [status, form]);

  const onFinish = async (body) => {
    try {
      if (status === 'putHold') {
        await putHold({ parentId, body }).unwrap();
      } else if (status === 'removeHold') {
        await removeHold({ parentId, body }).unwrap();
      } else if (status === 'delete') {
        await deleteRecommendation({ parentId, body }).unwrap();
      }
      refetch();
      onClose();
    } catch (err) {}
  };

  return (
    <>
      <Modal
        title={titles[status]}
        open={!!status}
        confirmLoading={puttingHold || removingHold || deleting}
        onOk={() => form.submit()}
        onCancel={onClose}
      >
        <Form layout="vertical" form={form} onFinish={onFinish}>
          <Form.Item name="note" label="Please enter reason below" rules={[{ required: true }]}>
            <Input.TextArea autoSize={{ minRows: 3 }} />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default UpdateModal;
